import { render, staticRenderFns } from "./NotificationAddNew.vue?vue&type=template&id=3bf9a572&"
import script from "./NotificationAddNew.vue?vue&type=script&lang=js&"
export * from "./NotificationAddNew.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAddNew.vue?vue&type=style&index=0&id=3bf9a572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports